import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Calendar, Clock } from 'lucide-react'
import type { Season } from './types'
import { formatDate } from './utils'

interface SeasonInfoCardProps {
  season: Season
  daysRemaining: number | null
}

export function SeasonInfoCard({
  season,
  daysRemaining,
}: SeasonInfoCardProps) {
  if (!season.startDate || !season.endDate) return null

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          Season Info
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 sm:grid-cols-3">
          <div>
            <p className="text-sm text-muted-foreground">Season Dates</p>
            <p className="font-medium">
              {formatDate(season.startDate)} - {formatDate(season.endDate)}
            </p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Time Remaining</p>
            <p className="font-medium">
              {season.status === 'active' && daysRemaining !== null ? (
                `${daysRemaining} days left`
              ) : season.status === 'upcoming' ? (
                'Not started'
              ) : (
                'Season ended'
              )}
            </p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Your Status</p>
            <p className="font-medium flex items-center gap-1">
              <Clock className="h-4 w-4 text-muted-foreground" />
              Spectating
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
